module.exports = __webpack_public_path__ + "img/full6-min.913447e3.png";